<span [class.prof-av]="size === 'sm'" [class.prof-av-lg]="size === 'lg'">
  <img *ngIf="imageUrl; else initialsTpl" [src]="imageUrl" alt="">
  <ng-template #initialsTpl>{{ initials() }}</ng-template>
</span>
